import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import { conversationSidebarConfig } from '../../utils/conversationSidebarItems';
import styles from './conversationSidebarButton.module.scss';
/** Represents the conversation sidebar button. */
export const ConversationSidebarButton = ({ sidebarId, isActive, onClick, }) => {
    const { icon } = conversationSidebarConfig[sidebarId];
    const classNames = classnames(styles.root, { [styles.isActive]: isActive });
    return (_jsx("button", Object.assign({ className: classNames, onClick: onClick }, { children: _jsx(Icon, { name: icon }) })));
};
